import {StyleSheet} from 'react-native';
import {connect} from 'react-redux';
import {constant, get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import OrderHistoryList from '/component/partial/OrderHistoryList';
import {fromProps} from '/util/selector.util';

const styles = StyleSheet.create({base: {paddingTop: 10}});

export default connect(
  createStructuredSelector({
    clientId: fromProps(get('coachId')),
    style: constant(styles),
  }),
)(OrderHistoryList);
